export { ErrorMessage, HelperMessage, Label, RequiredAsterisk } from '@atlaskit/form';
import Button from '@atlaskit/button';
import TextArea from '@atlaskit/textarea';
import Textfield from '@atlaskit/textfield';
import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const SeamlessTextfield = styled(Textfield)`
  margin-left: ${token('space.100', '8px')};
  &&:not(:hover) {
    background-color: transparent;
  }

  &&:not(:focus-within) {
    border-color: transparent;
  }
`;

export const SeamlessTextArea = styled(TextArea)`
  &&:not(:hover) {
    background-color: transparent;
  }

  &&:not(:focus-within) {
    border-color: transparent;
  }
`;

/**
 * Renders a button with 100% width and particular spacing that is more aligned with forms. Pass an icon
 * with size="small" as iconBefore. The spacing will make sure that the icon is aligned with checkboxes
 * and other form elements.
 */
export const FormButton = styled(Button).attrs({
  shouldFitContainer: true,
  appearance: 'subtle',
  spacing: 'compact',
})`
  && {
    height: 40px;
    text-align: left;
    align-items: center;
    color: inherit !important;
    padding: 0 2px;
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
